import {Switch} from 'react-router-dom';

import {RedirectToPrivateRoute, PrivateRoute, ROUTE_CONFIG} from 'utils';

import {ClientSession} from './ClientSession';
import {SessionResult} from './SessionResult';

export const Content: React.FC = () => (
    <Switch>
        <PrivateRoute {...ROUTE_CONFIG.CONTENT.SESSION_RESULT} component={SessionResult} />
        <PrivateRoute {...ROUTE_CONFIG.CONTENT.CLIENT_SESSION} component={ClientSession} />
        <RedirectToPrivateRoute
            routes={[
                ROUTE_CONFIG.CONTENT.SESSION_RESULT,
                ROUTE_CONFIG.CONTENT.CLIENT_SESSION
            ]}
        />
    </Switch>
);
